export const CITIES = [
  "Philadelphia",
  "New York",
  "Los Angeles",
  "Miami",
  "Chicago",
  "Austin",
];

export const POSITIONS = ["Forward", "Midfielder", "Defender", "Goalkeeper"];

export const LEAGUE_PREFERENCES = ["Women's", "Co-ed", "Men's", "Open"];

export const SCOUTING_ORIGINS = ["GoodRec", "CASA"];
